import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/icons/wildlife/next.svg';

const NextIcon = ( props ) => {
    const className = `icon-wrapper ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
NextIcon.defaultProps = {
    className: '',
};

export default NextIcon;
